import { Component, OnInit, AfterViewInit, Input, ChangeDetectorRef } from '@angular/core';

import { GridColumn, GridCommand } from '../../grid-control.model';
import { SettingService } from '../../../../services/setting/setting.service';
import { NotifyService } from '../../../../services/notify/notify.service';
import { MobileMaxWidth } from '../../../../constants/responsive';

@Component({
  selector: 'sd-grid-sub-information',
  templateUrl: './grid-sub-information.component.html',
  styleUrls: ['../../../../assets/css/button.scss',
    '../../../../assets/css/label.scss',
    '../../../../assets/css/scrollbar.scss',
    '../../../../assets/css/input.scss',
    '../../../../assets/css/select.scss',
    './grid-sub-information.component.scss']
})
export class GridSubInformationComponent implements OnInit, AfterViewInit {
  @Input() height = 'auto';
  @Input() columns: GridColumn[] = [];
  @Input() commands: GridCommand[] = [];

  @Input() subItems: any[] = [];
  isMobile = window.innerWidth < MobileMaxWidth;
  filter: any = {};
  constructor(
    private ref: ChangeDetectorRef,
    private settingService: SettingService,
    private notifyService: NotifyService
  ) { }

  ngOnInit() {
  }

  ngAfterViewInit() {

  }

  updateFilter() {

  }
  trackById(index, item) {
    return item.id;
  }

  onEditorChange = (column: GridColumn, item: any, value: any) => {
    if (column.type !== 'children') {
      column.editor?.change(item, value);
      this.ref.detectChanges();
    }
  }
}
